import { isCurrentTimeBetweenSegmentDates } from './find-segment-by-date';

/**
 * Unlike statements, presences get no quantisation slack in either direction:
 * the instant they store is what reports and the review seek jump to, so the cut
 * bounds are checked exactly. Do not route this through isWithinCutWindow.
 */
function isPresenceAddDisabled(
  cutStart: Date | null,
  cutEnd: Date | null,
  playerDatetime: Date | null
): boolean {
  if (!cutStart || !playerDatetime) return true;
  if (!cutEnd) return playerDatetime.getTime() < cutStart.getTime();

  return !isCurrentTimeBetweenSegmentDates(cutStart, cutEnd, playerDatetime);
}

export { isPresenceAddDisabled };
